import $ from 'jquery';
import Gallery from "blueimp-gallery";
// import skrollr from 'skrollr';
import { initSiv, trace, updateSiv } from 'rytm-helpers';
import { updateLinks } from './linksFix'

let s = false;
// ### toggle class of <html> element
const onToggleClass = (e) => {
  e.preventDefault();
  const btn = e.currentTarget;
  const className = btn.dataset.toggleClass;
  if (className) {
    document.documentElement.classList.toggle(className);
  }
};
// ### toggle search
const onToggleSearch = (e) => {
  e.preventDefault();
  const className = "search-open";
  const opening = !document.documentElement.classList.contains(className)
  document.documentElement.classList.toggle(className);
  // console.log("SEARCH TOGGLE", className, opening)
  if (opening) {
    // scroll top
    scrollToPos(0)
    // focus
    const input = document.querySelector("#global-search-input")
    if (input) {
      input.focus()
      setTimeout(() => {
        input.focus()
      }, 50)
    }
  }
  
};

// ### Window update
const windowUpdateTimer = false;
export const windowUpdate = (e) => {
  skrollrRefresh();
  updateSiv();
  updateLinks();
  // single shots:
  // clearTimeout(windowUpdateTimer)
  // windowUpdateTimer = setTimeout(() => {
  //   moveUpAndBelow()
  // }, 300)
};

const onCollapseButtonLabel = (e) => {
  let $collapse = $(e.target);
  let id = $collapse.attr("id");
  let $btn = $('a[href="#' + id + '"], button[data-target="#' + id + '"]');
  if ($btn.length) {
    let labelCollapsed = $btn.data("labelcollapsed");
    let labelExpanded = $btn.data("labelexpanded");
    const wrapper = $btn.get(0).querySelector('.label-wrapper')
    if (wrapper && labelCollapsed && labelExpanded) {
      if ($collapse.hasClass("show")) {
        wrapper.innerHTML = labelExpanded
      }
      else {
        wrapper.innerHTML = labelCollapsed
      }

    }
  }
}

const onBlueimpGalleryLinkClick = (e) => {
  e.preventDefault();
  let blueimpLinks = document.querySelectorAll('[data-gallery]');  
  let selector = e.currentTarget.getAttribute('data-gallery');
  let link = e.currentTarget;
  let options = {
    container: selector,
    event: e,
    index: link,
    titleElement: 'header'
  }
  Gallery(blueimpLinks, options);
}

// ### is Mobile?
const isMobile = () => window.innerWidth <= 768;

// ### skrollr refresh
const skrollrRefresh = () => {
  // if (!isMobile()) {
  //   if (!s) {
  //     s = skrollr.init({ forceHeight: false });
  //   } else {
  //     s.refresh($('.skrollr-element'));
  //   }
  // } else if (s) {
  //   s.destroy();
  // }
};

// stop video on modal hidden
const onModalHidden = (e) => {
  stopAllVideos()
}
// stop all videos
const stopAllVideos = (e) => {
  const listFrames = [...document.querySelectorAll('iframe')]
  listFrames.forEach((el) => {
    let src = el.src
    el.src = src;
  })
  const listVideos = [...document.querySelectorAll('video')]
  listVideos.forEach((el) => {
    el.pause()
  })
}

// scroll to position
export const scrollToPos = (topPx, time = 800, callback = null)=> {
  let $page = $('html, body');
  $page.animate({ scrollTop: topPx }, time, ()=>{
    if($.isFunction(callback)){
      callback()
    }
  });  
}

// Scroll to $target
export const scrollTo = ($target, offset = 0, time = 800, callback = null)=> {
  if (!$target.length) {
    return false;
  }
  let topPx = $target.offset().top - offset;
  scrollToPos(topPx, time, callback);
}

// ### INIT
export const initCommon = () => {
  initSiv({ singleShotMode: false });
  $('body').on('click', '*[data-toggle-class]', onToggleClass);
  $('body').on('click', '.search-toggle', onToggleSearch);
  $("body").on("contextmenu", "img", (e) => false); // disable 'save image as'
  $('body').on("shown.bs.collapse hidden.bs.collapse", ".collapse", onCollapseButtonLabel); // collapse change label
  $('body').on('click', 'a[data-gallery]', onBlueimpGalleryLinkClick); // blueimp gallery
  // on modal close
  $('body').on('hidden.bs.modal', '.modal', onModalHidden);
  $(document).on('DOMContentLoaded load', windowUpdate);
  $(window).on('resize', windowUpdate);
  windowUpdate();  
  // if (!isMobile()) {
  //   s = skrollr.init({ forceHeight: false });
  // }
};

